import Backend from 'i18next-http-backend';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
const i18nInstanceCreator = () => {
    return i18next.use(Backend).use(initReactI18next);
};
export default i18nInstanceCreator;
